import { FileText, Eye, CheckCircle, XCircle } from 'lucide-react';
import Button from './ui/Button';
import StatusBadge from './ui/StatusBadge';
import { useTranslation } from 'react-i18next';

export default function ReportTable({ reports, onPreview, onApprove, onReject, showActions = true, role }) {
    const { t } = useTranslation();

    if (!reports || reports.length === 0) {
        return (
            <div className="text-center py-12 bg-white rounded-xl border border-dashed border-gray-200">
                <p className="text-gray-500">Нет данных для отображения</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold border-b border-gray-100">
                            <th className="px-6 py-4">Название</th>
                            <th className="px-6 py-4">Автор</th>
                            <th className="px-6 py-4">Дата</th>
                            <th className="px-6 py-4">Статус</th>
                            {showActions && <th className="px-6 py-4 text-right">Действия</th>}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {reports.map((report) => (
                            <tr key={report.id} className="hover:bg-gray-50/50 transition-colors group">
                                <td className="px-6 py-4">
                                    <div className="flex items-center">
                                        <div className="p-2 bg-blue-50 text-blue-600 rounded-lg mr-3 group-hover:bg-blue-100 transition-colors">
                                            <FileText className="w-4 h-4" />
                                        </div>
                                        <span className="font-medium text-gray-900 line-clamp-1 max-w-[200px]" title={report.title}>
                                            {report.title}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="flex items-center">
                                        <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-xs font-bold text-gray-600 mr-2">
                                            {report.author_name?.[0]?.toUpperCase()}
                                        </div>
                                        <span className="text-sm text-gray-700">{report.author_name}</span>
                                    </div>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-500">
                                    {new Date(report.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4">
                                    <StatusBadge status={report.status} />
                                </td>
                                {showActions && (
                                    <td className="px-6 py-4 text-right">
                                        <div className="flex justify-end space-x-2">
                                            {report.file && (
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={() => onPreview(report)}
                                                    className="!p-2 text-gray-500 hover:text-blue-600"
                                                    title="Просмотр"
                                                >
                                                    <Eye className="w-4 h-4" />
                                                </Button>
                                            )}

                                            {/* Action Buttons based on Rolw */}
                                            {(onApprove && onReject) && (
                                                <>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={() => onReject(report)}
                                                        className="!p-2 text-red-500 hover:bg-red-50"
                                                        title="Отклонить"
                                                    >
                                                        <XCircle className="w-4 h-4" />
                                                    </Button>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={() => onApprove(report)}
                                                        className="!p-2 text-green-500 hover:bg-green-50"
                                                        title="Утвердить"
                                                    >
                                                        <CheckCircle className="w-4 h-4" />
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
